import axios, { AxiosResponse } from 'axios';

export interface IIsinTableParams {
    sluzba: string;
    isin?: string;
    isinnazev?: string;
    emic?: string;
    emicnazev?: string;
    order: string;
    limit: number;
    offset: number;
}

export interface IIsinTable {
    count: number;
    order: string;
    limit: number;
    offset: number;
    emise: IIsinTableData[];
}

export interface IIsinTableData {
    isin: string;
    isinnazev: string;
    emic: string;
    emicnazev: string;
}

export const isinTableDataApi = (data: IIsinTableParams) => {
    return axios({
        method: 'GET',
        url: 'Sluzby/Emise',
        params: data
    }).then((resp: AxiosResponse<IIsinTable>) => resp.data);
};
